<template>
  <div class="unit-box elevation-2" style="position: relative;">
    <v-layout row wrap>
      <v-flex xs12>
        <span>UNIDADE <strong class="text-uppercase">{{ unitName }}</strong> - CÓDIGO: <strong>{{ unitCode }}</strong></span>
      </v-flex>
      <!-- <v-flex xs6>
        <span>TURMAS REGISTRADAS <strong>{{ unitQuantity }}</strong></span>
      </v-flex> -->
      <v-flex xs12 v-if="exclusionError" @click="exclusionError = false">
        <span class="red--text"><strong>ESTA UNIDADE NÃO PODE SER EXCLUIDA! HÁ DEPENDENCIAS...</strong></span>
      </v-flex>
    </v-layout>
    <span @click.stop="deleteUnit()" class="delete-button"><i class="fas fa-trash-alt"></i></span>
  </div>
</template>

<script>
export default {
  props: ['unit-name', 'unit-code', 'unit-quantity', 'unit-id'],
  data() {
    return {
      exclusionError: false
    }
  },
  methods: {
    deleteUnit() {
      this.$http.delete(`units/${this.unitId}`, {}).then(data => {
        this.$emit('reloadUnits')
      }).catch(err => {
        this.exclusionError = true
      })
    }
  }
}
</script>

<style scoped>
  .unit-box {
    border-left: 10px solid #c4161c;
    border-top-left-radius: 6px;
    border-bottom-left-radius: 6px;
    background-color: #fff;
    padding-left: 20px;
    margin-bottom: 26px;
    cursor: pointer;
  }
  .delete-button {
    position: absolute;
    top: 15px;
    right: 15px;
  }
  .delete-button:hover {
    color: #c4161c;
  }
</style>
